import './src/styles/global.css'

const PROXIED_LANDING_PATHS = ['/hlm', '/m', '/homelight']
const IN_PAGE_SECTIONS = ['features', 'pricing', 'faq', 'start']

function normalizePath(path) {
  return (path || '/').replace(/\/$/, '') || '/'
}

// The HTML for "/" is sometimes what homelight.com/hlm receives. Gatsby then
// replaceState's the address bar to pagePath ("/"), and #features becomes
// homelight.com/#features. Point pagePath at the real browser path first.
export const onClientEntry = () => {
  const path = normalizePath(window.location.pathname)
  if (PROXIED_LANDING_PATHS.indexOf(path) !== -1 && window.pagePath && normalizePath(window.pagePath) !== path) {
    window.pagePath = path
  }

  document.addEventListener('click', onSectionClick, true)
}

function onSectionClick(event) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
  const anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null
  if (!anchor || anchor.target === '_blank') return

  const raw = anchor.getAttribute('href') || ''
  const hashAt = raw.indexOf('#')
  if (hashAt === -1) return
  let id = raw.slice(hashAt + 1).trim()
  try {
    id = decodeURIComponent(id)
  } catch (e) {
    return
  }
  if (IN_PAGE_SECTIONS.indexOf(id) === -1) return
  const target = document.getElementById(id)
  if (!target) return

  const here = normalizePath(window.location.pathname)
  const pathPart = raw.slice(0, hashAt)
  const dest = pathPart ? normalizePath(pathPart) : here
  const onLanding = here === '/' || PROXIED_LANDING_PATHS.indexOf(here) !== -1
  const toLanding = dest === '/' || PROXIED_LANDING_PATHS.indexOf(dest) !== -1
  if (!onLanding || !toLanding) return

  event.preventDefault()
  event.stopPropagation()
  target.scrollIntoView({behavior: 'smooth', block: 'start'})
  const next = window.location.pathname + window.location.search + '#' + id
  if (window.location.pathname + window.location.search + window.location.hash !== next) {
    window.history.pushState(null, '', next)
  }
}

// The logo sets this before leaving privacy or terms. Without it, Gatsby
// restores the last home-page scroll position, which is often the footer.
export const shouldUpdateScroll = () => {
  if (typeof window === 'undefined') return
  try {
    if (window.sessionStorage.getItem('hlm-scroll-top') !== '1') return
    window.sessionStorage.removeItem('hlm-scroll-top')
  } catch (e) {
    return
  }
  return false
}
